<div *ngIf="show">
  <a (click)="openRelatedEditModal.emit()" class="link">
    <img src="/assets/edit.svg" />
  </a>
</div>
